import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-hexagonsi-oms-lib',
  templateUrl: './hexagonsi-oms-lib.component.html',
  styles: [
  ]
})
export class HexagonsiOmsLibComponent implements OnInit {

  @Input() btName = '';
  constructor() { }

  ngOnInit(): void {
  }
  click(){
    alert('ng-zorro-' + this.btName);
  }

}
